<template>
  <div class="v2026-tagsec">
    <div class="v2026-tagsec-section-head">
      <span class="v2026-tagsec-section-label">แท็ก</span>
      <!-- Do NOT refactor these rows into a stable/default slot: Vue 2.7's stable-slot
           optimisation freezes state that does not flow through props. -->
      <b-dropdown size="sm" ref="dropdownTag" variant="link" no-caret right
                  menu-class="v2026-tagsec-menu"
                  toggle-class="v2026-tagsec-toggle"
                  :toggle-attrs="{ 'aria-label': 'เพิ่มแท็ก' }"
                  @shown="onTagDropdownShown">
        <template v-slot:button-content>
          <span class="v2026-tagsec-mask v2026-tagsec-add" aria-hidden="true"
                :style="maskStyle(icons.plus)"></span>
        </template>

        <div class="v2026-tagsec-search">
          <i class="fas fa-search v2026-tagsec-search__ico" aria-hidden="true"></i>
          <input ref="tagSearchInput" v-model.trim="tagSearch" type="text"
                 class="v2026-tagsec-search__input"
                 placeholder="ค้นหา Tags" aria-label="ค้นหา Tags">
        </div>

        <div class="v2026-tagsec-list" role="listbox">
          <div v-for="(tag, index) in filteredTags" :key="index"
               class="v2026-tagsec-row" role="option"
               :aria-label="'เพิ่มแท็ก ' + tag.name"
               :style="{ color: tag.color || 'var(--v2026-color-main)', borderColor: tag.color || 'var(--v2026-color-main)' }"
               @click="addConversationTag(tag)">
            <i class="fas fa-tag v2026-tagsec-row__ico" aria-hidden="true"></i>
            <span class="v2026-tagsec-row__name">{{ tag.name }}</span>
          </div>
          <div v-if="!filteredTags.length" class="v2026-tagsec-empty">
            {{ tagSearch ? 'ไม่พบแท็ก' : 'ยังไม่มีแท็ก' }}
          </div>
        </div>

        <div class="v2026-tagsec-foot" role="button" tabindex="0"
             @click="goToTagSetting()" @keydown.enter="goToTagSetting()">
          <!-- The glyph genuinely differs per panel: one is a stroke-based <img>, the other a
               CSS-mask span. Different asset AND different paint mechanism — not interchangeable. -->
          <span v-if="registry.settingIconMask" class="v2026-tagsec-mask v2026-tagsec-foot__ico"
                aria-hidden="true" :style="maskStyle(registry.settingIcon)"></span>
          <img v-else class="v2026-tagsec-foot__ico-img" aria-hidden="true"
               :src="registry.settingIcon" alt="">
          <span>ตั้งค่าแท็ก</span>
        </div>
      </b-dropdown>
    </div>
    <div class="v2026-tagsec__list">
      <ActionChipV2026 v-for="(tag, index) in customerTags" :key="index"
                       :label="tag.name" :color="tag.color" :fill="tagFill(tag.color)"
                       title="ลบแท็ก" class="v2026-tagsec-chip--removable"
                       @click="confirmDeleteConversationTag(tag)" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ActionChipV2026 from './ActionChipV2026.vue'
import { resolveTagChipFill } from './tagChipFill'

// The ONLY per-panel difference left: the footer glyph. One panel uses a stroke-based <img>, the
// other a CSS-mask span — different asset and different paint mechanism, so both are kept.
const TYPE_REGISTRY = {
  0: {
    name: 'customer',
    settingIcon: require('@/assets/icons2026/pencil-edit.svg'),
    settingIconMask: false
  },
  1: {
    name: 'professional',
    settingIcon: require('@/assets/icons2026/edit.svg'),
    settingIconMask: true
  }
}

export default {
  name: 'tags-section-v2026',
  components: {
    ActionChipV2026
  },
  props: {
    type: {
      type: Number,
      default: 0
    },
    // Never mutated here — refreshing selectedConversation.tags stays parent-owned.
    selectedConversation: {
      type: Object,
      default: null
    },
    tags: {
      type: Array,
      default: () => []
    },
    admin: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tagSearch: '',
      icons: {
        plus: require('@/assets/icons2026/plus.svg')
      }
    }
  },
  computed: {
    // Falls back to the customer row, so an unknown type can never produce an undefined src.
    registry () {
      return TYPE_REGISTRY[this.type] || TYPE_REGISTRY[0]
    },
    filteredTags () {
      const q = (this.tagSearch || '').trim().toLowerCase()
      return (this.tags || []).filter(t => t.id !== 0 &&
        (!q || (t.name || '').toLowerCase().includes(q)))
    },
    customerTags () {
      return (this.selectedConversation && Array.isArray(this.selectedConversation.tags))
        ? this.selectedConversation.tags : []
    }
  },
  methods: {
    tagFill (color) {
      return resolveTagChipFill(color)
    },
    onTagDropdownShown () {
      this.tagSearch = ''
      this.$nextTick(() => {
        if (this.$refs.tagSearchInput) {
          this.$refs.tagSearchInput.focus()
        }
      })
    },
    async addConversationTag (tag) {
      if (this.$refs.dropdownTag) {
        this.$refs.dropdownTag.hide(true)
      }
      const submitData = {
        admin_id: this.admin ? this.admin.id : null
      }
      const url = `/conversations/${this.selectedConversation.id}/tags/${tag.id}`
      try {
        await axios.post(url, submitData)
        this.$emit('notify', { variant: 'success', title: 'เพิ่มแท็กสำเร็จ', message: `เพิ่มแท็ก "${tag.name}" แล้ว` })
      } catch (e) {
        this.$emit('notify', { variant: 'danger', title: 'เกิดข้อผิดพลาด', message: 'เพิ่มแท็กไม่สำเร็จ กรุณาลองใหม่' })
      }
    },
    goToTagSetting () {
      this.$router.push('/settings/tag')
    },
    confirmDeleteConversationTag (tag) {
      this.$swal({
        text: 'คุณต้องการลบแท็กนี้ใช่หรือไม่',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.deleteConversationTag(tag)
        }
      })
    },
    async deleteConversationTag (tag) {
      const url = `/conversations/${this.selectedConversation.id}/tags/${tag.id}`
      try {
        await axios.delete(url)
        this.$emit('notify', { variant: 'success', title: 'ลบแท็กสำเร็จ', message: `ลบแท็ก "${tag.name}" แล้ว` })
      } catch (e) {
        this.$emit('notify', { variant: 'danger', title: 'เกิดข้อผิดพลาด', message: 'ลบแท็กไม่สำเร็จ กรุณาลองใหม่' })
      }
    },
    maskStyle (url) {
      return {
        '-webkit-mask-image': 'url(' + url + ')',
        'mask-image': 'url(' + url + ')'
      }
    }
  }
}
</script>

<style scoped>
.v2026-tagsec-mask {
  display: inline-block;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-icon);
}

.v2026-tagsec-section-label {
  font-size: var(--v2026-fs-section);
  font-weight: 600;
  color: var(--v2026-text-secondary);
}

.v2026-tagsec-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v2026-tagsec-add {
  width: 18px;
  height: 18px;
  background-color: var(--v2026-color-main);
}

.v2026-tagsec {
  padding: 0 var(--v2026-sp-4);
}
.v2026-tagsec__list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--v2026-sp-2);
  margin-top: var(--v2026-sp-2);
}

::v-deep .v2026-tagsec-chip--removable {
  cursor: pointer;
}

::v-deep .v2026-tagsec-menu {
  min-width: 240px;
  max-width: 280px;
  padding: var(--v2026-sp-2);
  margin: 0;
  background: var(--v2026-surface);
  border: 1px solid var(--v2026-border);
  border-radius: var(--v2026-r-card);
  box-shadow: 0 12px 40px rgba(16, 24, 40, 0.18);
}

.v2026-tagsec-search {
  display: flex;
  align-items: center;
  gap: var(--v2026-sp-2);
  padding: var(--v2026-sp-2) var(--v2026-sp-3);
  margin-bottom: var(--v2026-sp-2);
  background: var(--v2026-surface-sunken);
  border: 1px solid var(--v2026-border);
  border-radius: var(--v2026-r-tab);
}
.v2026-tagsec-search:focus-within {
  border-color: var(--v2026-color-main);
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}
.v2026-tagsec-search__ico {
  flex: 0 0 auto;
  font-size: 14px;
  color: var(--v2026-text-muted);
}
.v2026-tagsec-search__input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: var(--v2026-text);
  font-size: var(--v2026-fs-body);
}
.v2026-tagsec-search__input::placeholder {
  color: var(--v2026-text-muted);
}

.v2026-tagsec-list {
  max-height: 260px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-1);
}
.v2026-tagsec-list::-webkit-scrollbar {
  width: 6px;
}
.v2026-tagsec-list::-webkit-scrollbar-thumb {
  background: #31C1D7;
  border-radius: 3px;
}

.v2026-tagsec-row {
  display: flex;
  align-items: center;
  gap: var(--v2026-sp-2);
  padding: var(--v2026-sp-2) var(--v2026-sp-3);
  border: 1px solid var(--v2026-color-main);
  border-radius: var(--v2026-r-box);
  background: var(--v2026-surface);
  font-size: var(--v2026-fs-meta);
  cursor: pointer;
}
.v2026-tagsec-row:hover {
  background: var(--v2026-surface-hover);
}
.v2026-tagsec-row__ico {
  flex: 0 0 auto;
  font-size: 12px;
}
.v2026-tagsec-row__name {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v2026-tagsec-empty {
  padding: var(--v2026-sp-3);
  text-align: center;
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-muted);
}

.v2026-tagsec-foot {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--v2026-sp-2);
  margin-top: var(--v2026-sp-2);
  padding: var(--v2026-sp-2);
  border-top: 1px solid var(--v2026-border);
  color: var(--v2026-text-secondary);
  font-size: var(--v2026-fs-body);
  cursor: pointer;
}
.v2026-tagsec-foot:hover {
  background: var(--v2026-surface-hover);
  border-radius: var(--v2026-r-tab);
}
.v2026-tagsec-foot:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
  border-radius: var(--v2026-r-tab);
}

.v2026-tagsec-foot__ico {
  width: 14px;
  height: 14px;
  background-color: var(--v2026-text-secondary);
}
.v2026-tagsec-foot__ico-img {
  width: 14px;
  height: 14px;
  object-fit: contain;
  display: block;
}
</style>
